import React, { useContext } from 'react';

interface LangContextValue {
  lang: string | null;
}

export const LangContext = React.createContext<LangContextValue>({
  lang: null
});

export default function useLang() {
  return useContext(LangContext);
}
